export const sponserCardList = [
  {
    question: 'Q1. 기부금은 어디에 쓰이나요?',
    answer:
      '여러분들의 소중한 후원은, 서버비와 서비스 유지비용으로 지출할 계획입니다. 이 비용은 서비스가 돌아가기 위한 필수 비용이며, 그외에도 현재 피플은 각종 운영비를 자부담하고 있습니다. 운영비 외의 추가적인 지원이 생길경우, 헌혈문화정착, 헌혈캠페인등에 사용될 예정입니다.',
  },
  {
    question: 'Q2. 왜 정기후원만 받나요?',
    answer:
      '소액이라도, 지속적으로 이러한 사회문제에 관심을 가지고, 함께해줄 분을 찾고 싶습니다! 일시적인 관심이 아니라, 지속적으로 헌혈에 관심을 가져주시고, 피플의 따듯한 여정에 함께 해주시길 부탁드립니다!',
  },
  {
    question: 'Q3. 기부금 영수증 되나요?',
    answer:
      '현재 피플은 비영리법인이 아닌 관계로, 기부금 영수증발급이 어렵습니다. 하지만, 법인이나 사업자로 100만원이상의 돈을 후원하셔서 기부금영수증을 꼭 발급받기를 희망하시는 분은 ‘함께일하는재단’ 담당자 (전화번호: 02-330-0730 )으로 문의바랍니다.',
  },
];

export const donationCardList = [
  {
    name: '피플이4414',
    title: '사랑많고 다정한 막내아이의 생명을 구하고 싶어요!! 도와주세요!!',
    content:
      '아이의 병원 이름표 스티커를 쳐다보고 있노라면 왜 내 아이의 이름이 저기에 있을까를 생각합니다. 저는 소아에게는 아주 드문 종류의 백혈병을 진단받고 병마와 싸우고 있는 10살 아이의 엄마입니다...',
    renew: 6,
    blood: 'AB',
    donationType: '혈소판헌혈',
  },
  {
    name: '피플이4157',
    title: 'O형 백혈구 헌혈 부탁드립니다',
    content:
      '안녕하세요. 소아암(급성림프구성백혈병)을 앓고 있는 시윤이의 백혈구 수혈해 주실분을 찾고 있습니다. 시윤이는 22년 4월 10살때 첫진단을 받고 동종이식후 올해 8월에 재발 판정을 받았습니다. 재관해 실패하면서 골수회복이 되지않아...',
    renew: 3,
    blood: 'O',
    donationType: '백혈구헌혈',
  },
  {
    name: '피플이4613',
    title: '위암환자이며 어린 두아이의 엄마를 살려주세요',
    content:
      '제 동생에 6월에 미만형 위암 4기 복막 난소 전이로 수술불가 항암 1차 이후 위암도 줄었다고 하고 복수도 안늘고 했는데.. 코로나 걸리고 복수가 급 늘어서 1차약은 내성판단 2차 항암 하는데.. 부작용이 너무 심해서 못먹고 늘어난 복수에 옆구리 통증 호소 복수 5리터...',
    renew: 1,
    blood: 'AB',
    donationType: '혈소판헌혈',
  },
  {
    name: '피플이3515',
    title: 'AB형 혈소판 지정헌혈로 제 아내를 살려주세요',
    content:
      '저희는 AB형 혈소판 지정현혈을 구하고 있습니다. 저는 급성골수성백혈병(M5b)로 투병중인 환자의 남편입니다. 조혈모세포이식후 골수기능의 저하로 혈소판의 거의 없는 상태입니다. 피플회원님들의 혈소판 지정헌혈을 간곡히 부탁드립니다....',
    renew: 4,
    blood: 'AB',
    donationType: '혈소판헌혈',
  },
];

export const thanksLetters = [
  '/imgs/sponser/letterCard1.svg',
  '/imgs/sponser/letterCard2.svg',
  '/imgs/sponser/letterCard3.svg',
  '/imgs/sponser/letterCard4.svg',
  '/imgs/sponser/letterCard5.svg',
  '/imgs/sponser/letterCard6.svg',
];

export const thanksLettersMb = [
  '/imgs/sponser/letterCard1-mb.svg',
  '/imgs/sponser/letterCard2-mb.svg',
  '/imgs/sponser/letterCard3-mb.svg',
  '/imgs/sponser/letterCard4-mb.svg',
  '/imgs/sponser/letterCard5-mb.svg',
  '/imgs/sponser/letterCard6-mb.svg',
];
